import React from 'react';

export const PacedIcon = () => {
  return (
    <>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.75"
          y="0.75"
          width="30.5"
          height="30.5"
          rx="3.25"
          stroke="#0099C7"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
        <rect x="19" y="7" width="8" height="1.5" rx="0.75" fill="#0099C7" />
        <rect x="19" y="10" width="6" height="1.5" rx="0.75" fill="#0099C7" />
        <path
          d="M16.4996 21.5L16.2371 20.7974C15.9439 20.907 15.7496 21.187 15.7496 21.5H16.4996ZM24.7786 18.4057L25.0411 19.1083L25.0411 19.1083L24.7786 18.4057ZM15.7496 26C15.7496 26.4142 16.0854 26.75 16.4996 26.75C16.9138 26.75 17.2496 26.4142 17.2496 26L15.7496 26ZM23.7871 15.396L23.9914 16.1176L23.9914 16.1176L23.7871 15.396ZM13.9996 17.5L13.9996 16.75L13.9996 16.75V17.5ZM8.99944 17.5L8.99944 16.75L8.99944 16.75V17.5ZM5.99964 20.5L5.24964 20.5L5.99964 20.5ZM5.24968 26C5.24968 26.4142 5.58547 26.75 5.99968 26.75C6.41389 26.75 6.74968 26.4142 6.74968 26L5.24968 26ZM24.2236 15.3354L24.2236 14.5854L24.2236 14.5854L24.2236 15.3354ZM16.7622 22.2025L25.0411 19.1083L24.516 17.7032L16.2371 20.7974L16.7622 22.2025ZM15.7496 21.5L15.7496 26L17.2496 26L17.2496 21.5H15.7496ZM23.5829 14.6743C22.9677 14.8484 21.0925 15.3713 19.095 15.8501C17.0611 16.3375 15.0149 16.75 13.9996 16.75L13.9996 18.25C15.2264 18.25 17.4548 17.7856 19.4446 17.3087C21.4708 16.8231 23.3683 16.294 23.9914 16.1176L23.5829 14.6743ZM13.9996 16.75L8.99944 16.75L8.99944 18.25L13.9996 18.25V16.75ZM5.24964 20.5L5.24968 26L6.74968 26L6.74964 20.5L5.24964 20.5ZM8.99944 16.75C6.9283 16.75 5.24963 18.429 5.24964 20.5L6.74964 20.5C6.74963 19.2573 7.75686 18.25 8.99944 18.25V16.75ZM24.2236 14.5854C24.0061 14.5854 23.7924 14.615 23.5829 14.6743L23.9914 16.1176C24.0677 16.096 24.1439 16.0854 24.2236 16.0854L24.2236 14.5854ZM25.0411 19.1083C27.4779 18.1975 26.8249 14.5854 24.2236 14.5854L24.2236 16.0854C25.154 16.0854 25.3876 17.3774 24.516 17.7032L25.0411 19.1083Z"
          fill="#0099C7"
        />
        <circle
          cx="12"
          cy="11.5"
          r="3.75"
          stroke="#0099C7"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
